import { LOCALE_OPTIONS } from '@/constants/enum';
import { isEmpty } from '@/helpers';

import {
  handleSaveWidgetTextDetail,
  handleSetWidgetTextState,
  widgetTextDetailSelector,
  widgetTextStateSelector,
} from '@/redux/slice/widgetText.slice';
import { Card, FormLayout, Select, TextField } from '@shopify/polaris';

import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

const GeneralInfo = () => {
  const { t } = useTranslation('translation');
  const dispatch = useDispatch();

  const widgetTextDetail = useSelector(widgetTextDetailSelector);
  const widgetTextState = useSelector(widgetTextStateSelector);

  const localeOptions = useMemo(
    () =>
      Object.values(LOCALE_OPTIONS).map((option) => ({
        label: t(`locale.options.${option}`),
        value: option,
      })),
    [t],
  );

  return (
    <div id="text-detail-general">
      <Card padding="400">
        <FormLayout>
          <FormLayout.Group>
            <TextField
              label={t('generalInfo.languageName')}
              value={widgetTextDetail.name}
              onChange={(value: string) => {
                dispatch(handleSetWidgetTextState({ isSaving: false }));
                dispatch(handleSaveWidgetTextDetail({ name: value }));
              }}
              requiredIndicator
              autoComplete="off"
              error={widgetTextState.isSaving && isEmpty(widgetTextDetail.name?.trim()) && 'Language name is required'}
            />

            <TextField
              label={t('generalInfo.languageCode')}
              value={widgetTextDetail.code}
              onChange={() => {}}
              autoComplete="off"
              disabled
            />
          </FormLayout.Group>

          <FormLayout.Group>
            <Select
              label={t('generalInfo.calendarLocale')}
              options={localeOptions}
              value={widgetTextDetail.calendarLocale}
              onChange={(value: string) => dispatch(handleSaveWidgetTextDetail({ calendarLocale: value }))}
              disabled
            />
          </FormLayout.Group>
        </FormLayout>
      </Card>
    </div>
  );
};

export default GeneralInfo;
